import { Link } from "react-router-dom";
import { FlaskConical } from "lucide-react";
import { BloqStacked } from "@/components/brand/BloqLogo";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-bloq-bg px-5 py-10 text-white">
      <div className="pointer-events-none absolute inset-0 grain opacity-50" />
      <div className="pointer-events-none absolute -top-32 left-1/2 h-[440px] w-[440px] -translate-x-1/2 rounded-full bg-bloq-mint/10 blur-[130px]" />
      <div className="pointer-events-none absolute bottom-0 right-0 h-[360px] w-[360px] rounded-full bg-bloq-purple/12 blur-[140px]" />

      <div className="relative z-10 w-full max-w-md animate-fade-up">
        <Link to="/" className="mb-5 flex flex-col items-center" data-testid="auth-home-link">
          <BloqStacked size={150} />
        </Link>

        <div className="mb-6 flex justify-center">
          <span
            className="inline-flex items-center gap-2 rounded-full border border-bloq-mint/30 bg-bloq-mint/10 px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-bloq-mint"
            data-testid="private-beta-badge"
          >
            <FlaskConical className="h-3.5 w-3.5" />
            Currently in private beta testing
          </span>
        </div>

        <div className="rounded-[1.75rem] border border-white/10 bg-bloq-s1/80 p-7 shadow-glass backdrop-blur-xl sm:p-9">
          <h1 className="text-2xl font-bold">{title}</h1>
          {subtitle && <p className="mt-1.5 text-sm text-bloq-muted">{subtitle}</p>}
          <div className="mt-7">{children}</div>
        </div>

        {footer && <div className="mt-6 text-center text-sm text-bloq-muted">{footer}</div>}
      </div>
    </div>
  );
}
